module.exports = __webpack_public_path__ + "static/dalia-pugatsch-video-7b5f7b4327ed0a2e4acc5134c820a4a2.ogv";